"use client";

import dynamic from "next/dynamic";

import type { SliderGenericProps } from "./SliderGeneric";

const SliderGeneric = dynamic(() => import("./SliderGeneric").then(mod => mod.SliderGeneric));

export default function SliderGenericWrapper(props: SliderGenericProps) {
  return <SliderGeneric {...props} />;
}
